import PropTypes from 'prop-types'
import React, { Component } from 'react'
import {
    Button,
    Container,
    Divider,
    Grid,
    Header,
    Icon,
    Image,
    List,
    Menu,
    Responsive,
    Segment,
    Sidebar,
    Visibility,
} from 'semantic-ui-react'

import {Route, withRouter } from 'react-router-dom';


import president_photo from '../../president_photo.jpg'




function HomeMain (props) {


    return (
        <div>
            <Segment style={{padding: '8em 0em'}} vertical>
                <Grid container stackable verticalAlign='middle'>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Header as='h3' style={{fontSize: '2em'}}>
                                Мы сделаем так чтобы на вас работали лучшии инновации
                            </Header>
                            <p style={{fontSize: '1.33em'}}>
                                Мы автоматизируем ваш бизнес и поможем избавится от ненужной бюрократии.
                                Мы сделаем ваш бизнес таким, чтобы вы концентрировались на самых важных задачах.


                            </p>
                            <Header as='h3' style={{fontSize: '2em'}}>
                                Мы создаем проекты международного уровня
                            </Header>
                            <p style={{fontSize: '1.33em'}}>
                                У нас есть высоко квалифицированные специалисты которые работали во всемирно известных компаниях как
                                CNN
                            </p>
                        </Grid.Column>
                        <Grid.Column floated='right' width={6}>
                            <Image bordered rounded size='large' src={president_photo}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column textAlign='center'>
                            {/* <Button size='huge'>Check Them Out</Button> */}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>

            <Segment style={{padding: '0em'}} vertical>
                <Grid celled='internally' columns='equal' stackable>
                    <Grid.Row textAlign='center'>
                        <Grid.Column style={{paddingBottom: '5em', paddingTop: '5em'}}>
                            <Header as='h3' style={{fontSize: '2em'}}>
                                "Иновационные IT системы помогут избавится от коррупции"
                            </Header>
                            <p style={{fontSize: '1.33em'}}>Сказал Президент Узбекистана при ознакомлении с нашей системой в Milana
                                Textile</p>
                        </Grid.Column>
                        <Grid.Column style={{paddingBottom: '5em', paddingTop: '5em'}}>
                            <Header as='h3' style={{fontSize: '2em'}}>
                                Мы сделаем вашу работу эффективнее
                            </Header>
                            <p style={{fontSize: '1.33em'}}>
                                {/* <Image avatar src='/images/avatar/large/nan.jpg' /> */}
                                {/* <b>Nan</b> Chief Fun Officer Acme Toys */}
                                Мы помогаем извлечь максимум возможного для клиента из совокупности всех современных технологий (как
                                опробованных, так и новейших, быстро развивающихся),
                                чтобы внедрять инновации, создавать эффективные решения и увеличивать продуктивность.
                            </p>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>

            <Segment style={{padding: '8em 0em'}} vertical>
                <Container text>
                    <Header as='h3' style={{fontSize: '2em'}}>
                        Успех вашей организации зависит от правильно построенной системы управления
                    </Header>
                    <p style={{fontSize: '1.33em'}}>
                        Мы проанализируем недостатки и неэффективные участки в работе вашей организации и разработаем для вас
                        систему автоматизации
                    </p>
                    {/* <Button as='a' size='large'>
          Read More
        </Button> */}

                    <Divider
                        as='h4'
                        className='header'
                        horizontal
                        style={{margin: '3em 0em', textTransform: 'uppercase'}}
                    >
                        {/* <a href='#'>Case Studies</a> */}
                    </Divider>

                    {/* <Header as='h3' style={{ fontSize: '2em' }}>
          Did We Tell You About Our Bananas?
        </Header>
        <p style={{ fontSize: '1.33em' }}>
          Yes I know you probably disregarded the earlier boasts as non-sequitur filler content, but
          it's really true. It took years of gene splicing and combinatory DNA research, but our
          bananas can really dance.
        </p>
        <Button as='a' size='large'>
          I'm Still Quite Interested
        </Button> */}
                </Container>
            </Segment>

        </div>
    )
}

export default HomeMain